module.exports = __webpack_public_path__ + "img/Romantikk_Bildekunsten_og_musikken3.aa62b680.jpg";